import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrUnpairCertificatePathParameters } from 'api/actions/hr-unpair-certificate/hr-unpair-certificate-path-parameters';
import { HrUnpairCertificateResponse } from 'api/actions/hr-unpair-certificate/hr-unpair-certificate-response';

type HrUnpairCertificateQueryParameters = Record<string, any>;

/**
 * The path of the HrUnpairCertificate action.
 */
export const hrUnpairCertificateActionPath = new SweetPath<keyof HrUnpairCertificatePathParameters>(
  '/api/hr/terms/{termId}/certificate',
  { path: '{param}' }
);

/**
 * Creates a contextualized HrUnpairCertificate actions.
 */
export default function createHrUnpairCertificateAction(axios: AxiosInstance) {
  return function hrUnpairCertificateAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: HrUnpairCertificatePathParameters;
    query?: HrUnpairCertificateQueryParameters;
  }) {
    const path = hrUnpairCertificateActionPath.insert(parameters);

    return axios.request<HrUnpairCertificateResponse, HrUnpairCertificateResponse>({
      method: 'delete',
      url: path,
      params: query,

      headers,
    });
  };
}
